import React from "react";

import { Spinner } from "../Spinner";

import styles from "./PageLoader.module.css";

type PageLoaderProps = {
	/** Already-translated wording for what is loading. */
	label: string;
};

/**
 * Whole-screen loading state for a page that has no chrome of its own to show yet — the tree editor
 * and full view, which are nothing but their canvas until the tree arrives. Pages that already
 * render a nav or header should place a {@link Spinner} inside it instead of covering it.
 */
export const PageLoader = ({ label }: PageLoaderProps) => (
	<div className={styles.root}>
		<Spinner label={label} />
	</div>
);
